import { jsx as _jsx } from "react/jsx-runtime";
import { StyledViewsTabContentComponent } from "./views-tab-component.scss";
import { viewsGridItems } from "./views-tab-consts.js";
import LiveBoardTabComponent from "../live-board-tab-component";
import { withGenericConfig } from "/contexts/generic-config-context";
const ViewsTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx(StyledViewsTabContentComponent, {
        className: "views-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.viewsTab.description"),
            gridItems: viewsGridItems,
            onCardClick: onCardClick
        })
    });
};
export default withGenericConfig(ViewsTabContentComponent);
